export const LAST_VISITED_URL_KEY = 'lastVisitedUrl';
export const PENULTIMATE_VISITED_URL_KEY = 'penultimateVisitedUrl';
export const PENULT_CRUMB_URL_KEY = 'penultCrumbUrl';
export const COOKIE_CONSENT_ACCEPTED = 'cookieConsentAccepted';
export const BASKET_CHANGED = 'basketChanged';
export const GUEST_EMAIL = 'guestEmail';
export const PRODUCT_COMPARE_LIST = 'product_compare_list';
export const REGISTRATION_EMAIL = 'registrationEmail';
export const CHOSEN_PAYMENT_OPTION = 'chosenPaymentOption';
export const IS_NEW_SESSION = 'isNewSession';
export const HAS_ACTIVE_SESSION = 'hasActiveSession';
export const APPLE_PAY_PAYMENT_FAILED = 'applePayPaymentFailed';
export const BUY_GET_POPUP_STORAGE_KEY = 'buyAndGetPopupOpened';
export const BASKET_CHANGED_STORAGE_KEY = 'basketChanged';
export const PERSONAL_SHOPPING_ADVICE_STORAGE_KEY = 'personalShoppingAdvice';
export const DEVICE_ID_STORAGE_KEY = 'device_id';
export const SHOP_NUMBER_STORAGE_KEY = 'shopNumber';
export const CUSTOMER_UUID = 'customerUUID';
export const SALE_ID = 'saleId';
export const RATING = 'rating';
export const SELECTED_STORE_STORAGE_KEY = 'selectedStore';
export const SEARCH_STORE_STORAGE_KEY = 'searchStore';
export const GUEST_USER_CHECKOUT_DATA = 'guestUserCheckoutData';
export const LOCAL_STORAGE_WISH_LIST_KEY = 'wishList';
